import React, { useState } from 'react';
import { WhatsAppOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const WhatsAppFloat = () => {
    const [isHovered, setIsHovered] = useState(false);

    let user_detail = {};
    try {
        user_detail = JSON.parse(localStorage.getItem("userData")) || {};
    } catch (e) {
        console.error("Error parsing userData", e);
    }

    const email = user_detail.emailid || user_detail.email || "";
    const username = user_detail.username || user_detail.name || "";

    return (
        <Tooltip title="Talk with our Team" placement="left">
            <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => {
                    const message = `Quick support for instantdm, \nEmail: ${email} \nUsername: ${username}`;
                    const encodedMessage = encodeURIComponent(message);
                    window.open(`https://wa.me/918903401690?text=${encodedMessage}`, '_blank');
                }}
                style={{
                    position: 'fixed',
                    right: 95,
                    bottom: 25,
                    width: 55,
                    height: 55,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 2000,
                    backgroundColor: isHovered ? '#25d366' : 'white',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    transition: 'all 0.3s ease'
                }}
            >
                <WhatsAppOutlined
                    style={{
                        fontSize: '30px',
                        color: isHovered ? 'white' : '#25d366',
                        transition: 'color 0.3s',
                        lineHeight: 1
                    }}
                />
            </div>
        </Tooltip>
    );
};

export default WhatsAppFloat;
